/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: 
 * class: Xml
 * root Object
 * @constructor
 */
window.Xml = function() {
};
$hxClasses['Xml'] = Xml;
/** @private @type {Array} */
Xml.__name__ = ["Xml"];
/** @type {XmlType} */
Xml.Element = "element";
/** @type {XmlType} */
Xml.PCData = "pcdata";
/** @type {XmlType} */
Xml.CData = "cdata";
/** @type {XmlType} */
Xml.Comment = "comment";
/** @type {XmlType} */
Xml.DocType = "doctype";
/** @type {XmlType} */
Xml.Prolog = "prolog";
/** @type {XmlType} */
Xml.Document = "document";


/**
 * parse
 *
 * $type TFun([{ name => str, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  str 
 * @return {Xml}
 */
Xml.parse = function(str) {
	return haxe.xml.Parser.parse(str);
};


/**
 * createElement
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  name 
 * @return {Xml}
 */
Xml.createElement = function(name) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.Element;
	r._children = new Array();
	r._attributes = new Hash();
	r.setNodeName(name);
	return r;
};


/**
 * createPCData
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  data 
 * @return {Xml}
 */
Xml.createPCData = function(data) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.PCData;
	r.setNodeValue(data);
	return r;
};


/**
 * createCData
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  data 
 * @return {Xml}
 */
Xml.createCData = function(data) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.CData;
	r.setNodeValue(data);
	return r;
};


/**
 * createComment
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  data 
 * @return {Xml}
 */
Xml.createComment = function(data) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.Comment;
	r.setNodeValue(data);
	return r;
};


/**
 * createDocType
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  data 
 * @return {Xml}
 */
Xml.createDocType = function(data) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.DocType;
	r.setNodeValue(data);
	return r;
};


/**
 * createProlog
 *
 * $type TFun([{ name => data, t => TInst(String,[]), opt => false }],TInst(Xml,[]))
 * @public
 * @static
 * @param {string}  data 
 * @return {Xml}
 */
Xml.createProlog = function(data) {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.Prolog;
	r.setNodeValue(data);
	return r;
};


/**
 * createDocument
 *
 * $type TFun([],TInst(Xml,[]))
 * @public
 * @static
 * @return {Xml}
 */
Xml.createDocument = function() {
	/** @type {Xml} */
	var r = new Xml();
	r.nodeType = Xml.Document;
	r._children = new Array();
	return r;
};


/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this Xml
 * @return {string}
 */
Xml.prototype.toString = function() {
	if(this.nodeType == Xml.PCData) return this._nodeValue;
	if(this.nodeType == Xml.CData) return "<![CDATA[" + this._nodeValue + "]]>";
	if(this.nodeType == Xml.Comment) return "<!--" + this._nodeValue + "-->";
	if(this.nodeType == Xml.DocType) return "<!DOCTYPE " + this._nodeValue + ">";
	if(this.nodeType == Xml.Prolog) return "<?" + this._nodeValue + "?>";
	/** @type {StringBuf} */
	var s = new StringBuf();
	
	if(this.nodeType == Xml.Element) {
		s.b += Std.string("<");
		s.b += Std.string(this._nodeName);
		var $it0 = this._attributes.keys();
		while( $it0.hasNext() ) {
			var k = $it0.next();
			s.b += Std.string(" ");
			s.b += Std.string(k);
			s.b += Std.string("=\"");
			s.b += Std.string(this._attributes.get(k));
			s.b += Std.string("\"");
		}
		if(this._children.length == 0) {
			s.b += Std.string("/>");
			return s.b;
		}
		s.b += Std.string(">");
	}
	
	var $it1 = this.iterator();
	while( $it1.hasNext() ) {
		var x = $it1.next();
		s.b += Std.string(x.toString());
	}
	
	if(this.nodeType == Xml.Element) {
		s.b += Std.string("</");
		s.b += Std.string(this._nodeName);
		s.b += Std.string(">");
	}
	return s.b;
};


/**
 * insertChild
 *
 * $type TFun([{ name => x, t => TInst(Xml,[]), opt => false },{ name => pos, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this Xml
 * @param {Xml}  x 
 * @param {number}  pos 
 * @return {void}
 */
Xml.prototype.insertChild = function(x,pos) {
	if(this._children == null) throw "bad nodetype";
	if(x._parent != null) HxOverrides.remove(x._parent._children,x);
	x._parent = this;
	this._children.splice(pos,0,x);
};


/**
 * removeChild
 *
 * $type TFun([{ name => x, t => TInst(Xml,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this Xml
 * @param {Xml}  x 
 * @return {boolean}
 */
Xml.prototype.removeChild = function(x) {
	if(this._children == null) throw "bad nodetype";
	/** @type {boolean} */
	var b = HxOverrides.remove(this._children,x);
	if(b) x._parent = null;
	return b;
};


/**
 * addChild
 *
 * $type TFun([{ name => x, t => TInst(Xml,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this Xml
 * @param {Xml}  x 
 * @return {void}
 */
Xml.prototype.addChild = function(x) {
	if(this._children == null) throw "bad nodetype";
	if(x._parent != null) HxOverrides.remove(x._parent._children,x);
	x._parent = this;
	this._children.push(x);
};


/**
 * firstElement
 *
 * $type TFun([],TInst(Xml,[]))
 * @public
 * @this Xml
 * @return {Xml}
 */
Xml.prototype.firstElement = function() {
	if(this._children == null) throw "bad nodetype";
	/** @type {number} */
	var cur = 0;
	/** @type {number} */
	var l = this._children.length;
	while(cur < l) {
		/** @type {Xml} */
		var n = this._children[cur];
		if(n.nodeType == Xml.Element) return n;
		cur++;
	}
	return null;
};


/**
 * firstChild
 *
 * $type TFun([],TInst(Xml,[]))
 * @public
 * @this Xml
 * @return {Xml}
 */
Xml.prototype.firstChild = function() {
	if(this._children == null) throw "bad nodetype";
	return this._children[0];
};


/**
 * elementsNamed
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TType(Iterator,[TInst(Xml,[])]))
 * @public
 * @this Xml
 * @param {string}  name 
 * @return {Iterator}
 */
Xml.prototype.elementsNamed = function(name) {
	if(this._children == null) throw "bad nodetype";
	return { cur : 0, x : this._children, hasNext : function() {
		/** @type {number} */
		var k = this.cur;
		/** @type {number} */
		var l = this.x.length;
		while(k < l) {
			/** @type {Object} */
			var n = this.x[k];
			if(n.nodeType == Xml.Element && n._nodeName == name) break;
			k++;
		}
		this.cur = k;
		return k < l;
	}, next : function() {
		/** @type {number} */
		var k = this.cur;
		/** @type {number} */
		var l = this.x.length;
		while(k < l) {
			/** @type {Object} */
			var n = this.x[k];
			k++;
			if(n.nodeType == Xml.Element && n._nodeName == name) {
				this.cur = k;
				return n;
			}
		}
		return null;
	}};
};


/**
 * elements
 *
 * $type TFun([],TType(Iterator,[TInst(Xml,[])]))
 * @public
 * @this Xml
 * @return {Iterator}
 */
Xml.prototype.elements = function() {
	if(this._children == null) throw "bad nodetype";
	return { cur : 0, x : this._children, hasNext : function() {
		/** @type {number} */
		var k = this.cur;
		/** @type {number} */
		var l = this.x.length;
		while(k < l) {
			if(this.x[k].nodeType == Xml.Element) break;
			k += 1;
		}
		this.cur = k;
		return k < l;
	}, next : function() {
		/** @type {number} */
		var k = this.cur;
		/** @type {number} */
		var l = this.x.length;
		while(k < l) {
			/** @type {Object} */
			var n = this.x[k];
			k += 1;
			if(n.nodeType == Xml.Element) {
				this.cur = k;
				return n;
			}
		}
		return null;
	}};
};


/**
 * iterator
 *
 * $type TFun([],TType(Iterator,[TInst(Xml,[])]))
 * @public
 * @this Xml
 * @return {Iterator}
 */
Xml.prototype.iterator = function() {
	if(this._children == null) throw "bad nodetype";
	return { cur : 0, x : this._children, hasNext : function() {
		return this.cur < this.x.length;
	}, next : function() {
		return this.x[this.cur++];
	}};
};


/**
 * attributes
 *
 * $type TFun([],TType(Iterator,[TInst(String,[])]))
 * @public
 * @this Xml
 * @return {Iterator}
 */
Xml.prototype.attributes = function() {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	return this._attributes.keys();
};


/**
 * exists
 *
 * $type TFun([{ name => att, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @public
 * @this Xml
 * @param {string}  att 
 * @return {boolean}
 */
Xml.prototype.exists = function(att) {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	return this._attributes.exists(att);
};


/**
 * remove
 *
 * $type TFun([{ name => att, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this Xml
 * @param {string}  att 
 * @return {void}
 */
Xml.prototype.remove = function(att) {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	this._attributes.remove(att);
};


/**
 * set
 *
 * $type TFun([{ name => att, t => TInst(String,[]), opt => false },{ name => value, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this Xml
 * @param {string}  att 
 * @param {string}  value 
 * @return {void}
 */
Xml.prototype.set = function(att,value) {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	this._attributes.set(att,value);
};


/**
 * get
 *
 * $type TFun([{ name => att, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @public
 * @this Xml
 * @param {string}  att 
 * @return {string}
 */
Xml.prototype.get = function(att) {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	return this._attributes.get(att);
};


/**
 * getParent
 *
 * $type TFun([],TInst(Xml,[]))
 * @private
 * @this Xml
 * @return {Xml}
 */
Xml.prototype.getParent = function() {
	return this._parent;
};


/**
 * setNodeValue
 *
 * $type TFun([{ name => v, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @private
 * @this Xml
 * @param {string}  v 
 * @return {string}
 */
Xml.prototype.setNodeValue = function(v) {
	if(this.nodeType == Xml.Element || this.nodeType == Xml.Document) throw "bad nodeType";
	return this._nodeValue = v;
};


/**
 * getNodeValue
 *
 * $type TFun([],TInst(String,[]))
 * @private
 * @this Xml
 * @return {string}
 */
Xml.prototype.getNodeValue = function() {
	if(this.nodeType == Xml.Element || this.nodeType == Xml.Document) throw "bad nodeType";
	return this._nodeValue;
};


/**
 * setNodeName
 *
 * $type TFun([{ name => n, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * @private
 * @this Xml
 * @param {string}  n 
 * @return {string}
 */
Xml.prototype.setNodeName = function(n) {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	return this._nodeName = n;
};


/**
 * getNodeName
 *
 * $type TFun([],TInst(String,[]))
 * @private
 * @this Xml
 * @return {string}
 */
Xml.prototype.getNodeName = function() {
	if(this.nodeType != Xml.Element) throw "bad nodeType";
	return this._nodeName;
};

/** @private @type {Xml} */
Xml.prototype._parent = null;
/** @private @type {Array} */
Xml.prototype._children = null;
/** @private @type {Hash} */
Xml.prototype._attributes = null;
/** @private @type {string} */
Xml.prototype._nodeValue = null;
/** @private @type {string} */
Xml.prototype._nodeName = null;
/** @type {Xml} */
Xml.prototype.parent = null;
/** @type {string} */
Xml.prototype.nodeValue = null;
/** @type {string} */
Xml.prototype.nodeName = null;
/** @type {XmlType} */
Xml.prototype.nodeType = null;
/** @type {Xml} */
Xml.prototype.__class__ = Xml;
